import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import TarifCards from "./components/TarifCards";
import WhyClear from "./components/WhyClear";
import FAQ from "./components/FAQ";
import FloatingButton from "./components/FloatingButton";

export default function Tarifs() {
  useSEO(seoData.tarifs);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <TarifCards />
        <WhyClear />
        <FAQ />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}